export const primaryColor = process.env.REACT_APP_HAP_STAP
  ? '#e62059'
  : '#BDC3C7';
